<template>
    <section class="event-attendance">
        <div class="spotter-branding">
            <div class="spotter-logo"/>
            <div class="spotter-buttons">
                <app-button @click="exit">Exit</app-button>
            </div>
        </div>
        <div class="main-content">
            <div class="sidebar">
                <div class="spacer"/>
                <div class="totals">Total Abs: {{ students.length }}</div>
                <div v-if="code" class="qr-code" @click="toggleFullscreen">
                    <span v-if="!fullscreen">Click To Enlarge</span>
                    <qriously :value="code" :size="height"/>
                </div>
                <div class="type">
                    <app-segment-control
                        v-model="type"
                        :options="[{ title: 'Override', value: 'override' }, { title: 'Enter', value: 'enter' }, { title: 'Exit', value: 'exit' }]"
                        name="event-list" />
                </div>
            </div>
            <div v-if="!fullscreen" class="student-list">
                <div
                    v-for="student in students"
                    :key="student.id">{{ student.first_name }} {{ student.last_name }}</div>
            </div>
            <div v-else class="code-instructions">
                <h3>Please scan the QA code on the left using the Spotter App to receive credit.</h3>
            </div>
        </div>
    </section>
</template>
<script>
import refreshes from '@/mixins/refreshes'
import ScanCode from '@/store/models/ScanCode'
import Student from '@/store/models/Student'

export default {
    name: 'page-events-attendance',
    mixins: [refreshes],
    props: ['event'],
    data() {
        return {
            code: null,
            type: 'override',
            students: [],
            seconds: 5,
            fullscreen: false,
            isLocked: false,
            vh: Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
        }
    },
    computed: {
        height() {
            if (!this.fullscreen) return 300
            return this.vh * 0.8 - 80
        }
    },
    created() {
        this.rotateCode()

        window.addEventListener('resize' , this.resizeCode)
    },
    destroyed() {
        window.removeEventListener('resize', this.resizeCode)
    },
    methods: {
        exit() {
            this.$fullscreen.exit()
        },
        rotateCode() {
            ScanCode.$fetchOne({
                uuid: this.event.uuid,
                type: this.type
            }).then(({ raw }) => {
                this.code = raw.code
            })

            if (!this.fullscreen) {
                Student.$fetchAll({
                    relation: 'events',
                    relation_uuid: this.event.uuid,
                    missing: true,
                    page: 0,
                    per_page: 50
                }).then(({ data }) => {
                    if (data && data.length > 100) {
                        this.fullscreen = true
                        this.isLocked = true
                        this.students = []
                    }
                    this.students = data
                })
            }
        },
        toggleFullscreen() {
            if (this.isLocked) return
            this.fullscreen = !this.fullscreen
        },
        resizeCode() {
            this.vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0)
        },
        tick() {
            this.rotateCode()
        }
    }
}
</script>

<style lang="stylus">
@import '../../../stylus/variables'

.event-attendance
    background: #FFF
    width: 100%
    height: 100%

    .main-content
        display: flex
        width: 100%
        height: 100%

        @media screen and (max-width: 480px)
            width: auto
            margin: -5px -20px
            display: flex
            justify-content: center

    .student-list
        font-size: 20px
        line-height: 30px
        flex-grow: 1
        padding: 100px 30px 30px 30px

        @media screen and (max-width: 480px)
            display: none

        div
            width: 33.333%
            display: inline-block
            padding: 10px 0px
            border-bottom: 1px solid $border-color

    .code-instructions
        display: flex
        align-items: center
        h3
            font-size: 40px;
            padding: 25px 50px;

    .sidebar
        flex-shrink: 0
        display: flex
        flex-flow: column
        background: $light-grey
        padding: 20px
        text-align: center

        @media screen and (max-width: 480px)
            padding: 10px 20px
            border-radius: 10px

        .spacer
            flex-grow: 1

        .totals
            width: 100%
            font-size: 18px
            padding-bottom: 20px

        .qr-code
            background: $white
            width: 100%
            align-self: flex-end
            border-radius: 8px
            span
                display: block
                padding: 5px 0 3px 0
            @media screen and (max-width: 480px)
                width: auto
                align-self: center
                border-radius: 5px

        .type
            margin-top: 20px

    .spotter-branding
        background: $dark-grey
        width: 100%
        height: 80px
        position: absolute
        top: 0px
        left: 0px
        display: flex

        @media screen and (max-width: 480px)
            display: none

        .spotter-logo
            width: 80px
            height: 80px
            background-image: url('/svg/spotter_logo.svg')
            background-size: 60% 60%
            background-position: center center
            background-repeat: no-repeat
            background-color: $spotter-blue
            flex-grow: 0
            flex-shrink: 0

        .spotter-buttons
            width: 100%
            text-align: right
            padding-top: 20px
            padding-right: 50px
</style>
